"use client";

import React from "react";
import { Switch } from "@headlessui/react";

interface SwitchToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  className?: string;
  srLabel?: string;
}

const SwitchToggle: React.FC<SwitchToggleProps> = ({
  checked,
  onChange,
  label,
  className = "",
  srLabel = "Toggle setting",
}) => {
  return (
    <div className={`flex items-center ${className}`}>
      <Switch
        checked={checked}
        onChange={onChange}
        className={`group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent ring-offset-slate-700 transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 focus:outline-hidden data-checked:bg-indigo-600 ${
          checked ? "bg-indigo-600" : "bg-slate-600"
        }`}
      >
        <span className="sr-only">{srLabel}</span>
        <span
          aria-hidden="true"
          className={`pointer-events-none inline-block size-5 transform rounded-full bg-slate-900 ring-0 shadow-sm transition duration-200 ease-in-out ${
            checked ? "translate-x-5" : "translate-x-0"
          }`}
        />
      </Switch>
      {label && (
        <span className="ml-3 text-sm/6 font-medium text-slate-900 dark:text-slate-200">
          {label}
        </span>
      )}
    </div>
  );
};

export default SwitchToggle;
